var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5V10M10 10V7.5M10 10H7.5M10 10H12.5M10.0001 17.5C8.63751 17.5 7.35979 17.1366 6.25854 16.5015C6.14975 16.4387 6.09528 16.4074 6.04411 16.3932C5.99648 16.3801 5.95396 16.3756 5.90466 16.379C5.85211 16.3826 5.79775 16.4007 5.68966 16.4367L3.76506 17.0783L3.76354 17.079C3.35743 17.2143 3.154 17.2821 3.0188 17.2339C2.901 17.1919 2.80816 17.0989 2.76615 16.9811C2.71798 16.846 2.78557 16.6433 2.92074 16.2377L2.92155 16.2352L3.56224 14.3132L3.56376 14.3091C3.59947 14.202 3.61755 14.1478 3.62112 14.0955C3.6245 14.0462 3.62001 14.0033 3.60684 13.9557C3.59288 13.9052 3.56207 13.8518 3.50095 13.7458L3.49849 13.7416C2.86337 12.6403 2.5 11.3626 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10C17.5 14.1421 14.1422 17.5 10.0001 17.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChatIcon);
export default __webpack_public_path__ + "static/media/newChatIcon.7d40c2da6ff19c064372a17fae6b1f20.svg";
export { ForwardRef as ReactComponent };